import React, { useRef, forwardRef, useState } from "react";
import { Link } from "react-router-dom";
import 'react-multi-carousel/lib/styles.css';
import Carousel from 'react-multi-carousel';
import { useWindowSize } from "../../../hooks/useWindowSize";
import logo from "../../../assets/logo.png"
import '../../../scss/new-landing.scss'

import Hero1 from '../../../assets/landing/hero-1.webp'
import Hero1m from '../../../assets/landing/hero-1-m.webp'
import Hero2 from '../../../assets/landing/hero-2.webp'
import Hero3 from '../../../assets/landing/hero-3.webp'
import Why1 from '../../../assets/landing/why-1.png'
import Why2 from '../../../assets/landing/why-2.png'
import Why3 from '../../../assets/landing/why-3.png'

import topStore1 from '../../../assets/landing/topStore1.png'
import topStore2 from '../../../assets/landing/topStore2.png'
import topStore3 from '../../../assets/landing/topStore3.png'
import topStore4 from '../../../assets/landing/topStore4.png'
import topStore5 from '../../../assets/landing/topStore5.png'
import topStore6 from '../../../assets/landing/topStore6.png'
import topStore7 from '../../../assets/landing/topStore7.png'
import topStore8 from '../../../assets/landing/topStore8.png'
import topStore9 from '../../../assets/landing/topStore9.jpg'
import topStore10 from '../../../assets/landing/topStore10.png'
import topStore11 from '../../../assets/landing/topStore11.png'

import How from '../../../assets/landing/how.webp'
import { Cards } from "./cardsV2";
import { Footer } from "./footer";
import GettingStartedForm from "../../../views/onBoarding/GettingStartedForm";
import { authActions } from "../../../redux/actions/onboarding";
import { connect } from "react-redux";
import { LoadingItem } from "../../../shared/components/loading";

const cards = [
    {
        name: "Create account",
        text: "Sign up with your store and personal information.",
    },
    {
        name: "Verify your account",
        text: "Enter the OTP sent to the email address you provided at signup.",
    },
    {
        name: "Add a bank account",
        text: "Add a bank account to your vendor dashboard for receiving payments.",
    },
    {
        name: "Add products to your store",
        text: "Add products to your store on MamiMarkets.",
    },
    {
        name: "Start selling",
        text: "Start selling on MamiMarkets.",
    },
];

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1025 },
        items: 3,
        slidesToSlide: 4,
    },
    tablet: {
        breakpoint: { max: 1024, min: 601 },
        items: 3,
        slidesToSlide: 4,
    },
    mobile: {
        breakpoint: { max: 600, min: 0 },
        items: 1,
        slidesToSlide: 1,
    },
};


const whyItems = [
    {
        icon: Why1,
        heading: "Boost your visibility",
        whyDetails: "Pick a convenient time for you. Enjoy 100% quality guarantee on every order."
    },
    {
        icon: Why2,
        heading: "$0 Sign-up/Commission",
        whyDetails: "No setup fees, commission, or hidden charges."
    },
    {
        icon: Why3,
        heading: "24/7 Support",
        whyDetails: "We only partner with top retailers that offer the finest products."
    }
]

export interface WhyItem {
    icon: string,
    heading: string,
    whyDetails: string,
}


const HeroSection = forwardRef<HTMLDivElement, any>(({ pageProps }, ref) => {
    const screenResolution: any = useWindowSize();

    return (
        <div className="hero-section" >
            <div className="hero-content">
                <div className="side-left">
                    <h1 className="main-heading">
                        Grow your business{" "}
                        {screenResolution?.width >= 425 && <br />}
                        with MamiMarkets
                    </h1>
                    <br />
                    <GettingStartedForm pageProps={pageProps} ref={ref} />
                </div>
                <div className="side-right">
                    <div className="main-img">
                        <img
                            loading="lazy"
                            src={screenResolution?.width >= 1025 ? Hero1 : Hero1m}
                            alt=""
                        />
                    </div>
                    <div className="other-imgs">
                        <div className="img-2">
                            <img loading="lazy" src={Hero2} alt="" />
                        </div>
                        <div className="img-3">
                            <img loading="lazy" src={Hero3} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

const WhyChoose = () => {

    return (
        <div className="why-choose" id="why-choose">
            <div className="why-heading">Why MamiMarkets?</div>
            <div className="why-items">
                {
                    whyItems.map((eachItem: WhyItem, index) => {
                        return (
                            <div className="each-why-item" key={index}>
                                <div className="item-icon">
                                    <img loading="lazy" src={eachItem.icon} alt="" />
                                </div>
                                <div className="item-heading">
                                    <h2>{eachItem.heading}</h2>
                                </div>
                                <div className="item-details">{eachItem.whyDetails} </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}
const HowWorks = ({ scrollToHero }: { scrollToHero: () => void }) => {
    const screenResolution: any = useWindowSize();
    const [isPlaying, setIsPlaying] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const isMobile = screenResolution?.width <= 768;
    const videoId = "gYk-XJTjepE";

    const handlePlay = () => {
        setIsPlaying(true);
        setIsLoading(true); 
    };

    const renderIframe = () => (
        <>
            {isLoading && (
                <LoadingItem />
            )}
            <iframe
                width="100%"
                height="315"
                src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                onLoad={() => setIsLoading(false)} // hide loader when video loads
                style={{ display: isLoading ? "none" : "block" }}
            />
        </>
    );

    return (
        <div className="how-works">
            {isMobile ? (
                <>
                    {/* Right-side first on mobile */}
                    <div className="right-side">
                        <div className="heading-text">
                            <h2>How MamiMarkets <br /> Works for Sellers</h2>
                        </div>
                        <div className="other-text">
                            We help sellers reach and sell to more customers.<br />
                            Watch our intro video to learn more
                        </div>
                        <div className="get-started-cta">
                            <button className="btn" onClick={scrollToHero}>Create your store</button>
                        </div>
                    </div>

                    {isPlaying ? renderIframe() : (
                        <div className="left-side">
                            <img loading="lazy" src={How} alt="" onClick={handlePlay} />
                        </div>
                    )}
                </>
            ) : (
                <>
                    {/* Left-side first on desktop */}
                    {isPlaying ? renderIframe() : (
                        <div className="left-side">
                            <img loading="lazy" src={How} alt="" onClick={handlePlay} />
                        </div>
                    )}

                    <div className="right-side">
                        <div className="heading-text">
                            <h2>How MamiMarkets <br /> Works for Sellers</h2>
                        </div>
                        <div className="other-text">
                            We help sellers reach and sell to more customers.<br />
                            Watch our intro video to learn more
                        </div>
                        <div className="get-started-cta">
                            <button className="btn" onClick={scrollToHero}>Create your store</button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};


const ControllerButtons = ({ next, previous, goToSlide, ...rest }: any) => {
    const { carouselState: { currentSlide } } = rest;

    return (
        <React.Fragment>
            <div className="custom_controller_wrap">
                <button className={currentSlide === 0 ? 'disabled_prev_btn' : 'prev_btn'} onClick={() => previous()}> </button>
                <button className="next_btn" onClick={() => next()}></button>
            </div>
        </React.Fragment>
    )
}

const PopularStores = ({ scrollToHero }: { scrollToHero: () => void }) => {
    const stores = [
        { name: "Akin’s", logo: topStore1 },
        { name: "Ministry of Agric", logo: topStore2 },
        { name: "Lollypex", logo: topStore3 },
        { name: "Gifted Fingers", logo: topStore4 },
        { name: "Foodmarket", logo: topStore5 },
        { name: "Mr Market Importer", logo: topStore6 },
        { name: "Sauce Point", logo: topStore7 },
        { name: "Bombay Spices", logo: topStore8 },
        { name: "QuickMart", logo: topStore9 },
        { name: "Alpha Stores", logo: topStore10 },
        { name: "Amaka Foods", logo: topStore11 },
    ];

    return (
        <section className="popular-stores">
            <div className="stores-left">
                <h2>
                    Join These Popular <br /> Stores on MamiMarkets
                </h2>
                <br />

                <button className="cta" onClick={scrollToHero}>Start for free</button>
                <br />
                <p>
                    Have a question? <a href="#faq">View our FAQs</a>
                </p>
            </div>

            <div className="stores-right">
                {stores.map((store, idx) => (
                    <div key={idx} className="store-card">
                        <img src={store.logo} alt={store.name} />
                    </div>
                ))}
                {/* Green "Take this spot" circle */}
                <div className="store-card highlight" onClick={scrollToHero}>
                    <span>Take this spot</span>
                </div>
            </div>
        </section>
    );
}

const LandingPage = (pageProps: any) => {
    const screenResolution: any = useWindowSize();
    const heroRef = useRef<HTMLDivElement | null>(null);


    const scrollToHero = () => {
        if (heroRef.current) {
            heroRef.current.scrollIntoView({ behavior: "smooth", block: "start" });

            // add glow class
            heroRef.current.classList.add("glow");
            setTimeout(() => {
                heroRef.current?.classList.remove("glow");
            }, 3000); // remove after 3 seconds
        }
    };
    return (
        <div className="containers2">
            <div className="landing-header">
                <div className="logo">
                    <a target="_blank" href="https://mamimarkets.com/">
                        <img src={logo} alt="" />
                    </a>
                </div>
                <div className="links">
                    <Link to={'/log-in'} className="login">Log in </Link>
                    <button
                        onClick={scrollToHero}
                        className="get-button get-button-2"
                    >
                        Get started
                    </button>

                </div>
            </div>
            <HeroSection ref={heroRef} pageProps={pageProps} />
            <WhyChoose />
            <PopularStores scrollToHero={scrollToHero} />
            <section className="steps-section">
                <div className="steps-header">
                    <h3>Get Started in 5 Simple Steps</h3>
                </div>

                <Carousel
                    responsive={responsive}
                    arrows
                    infinite={false}
                    swipeable
                    draggable
                    keyBoardControl
                    containerClass="steps-carousel"
                    itemClass="steps-carousel-item"
                >
                    {cards.map((elem, idx) => (
                        <div key={idx} className="step-card">
                            <div className="step-number">{idx + 1}</div>
                            <div className="step-content">
                                <h4>{elem?.name}</h4>
                                <p>{elem?.text}</p>
                            </div>
                        </div>
                    ))}
                </Carousel>
            </section>
            {/* <br /> */}
            <HowWorks scrollToHero={scrollToHero} />
            <Cards scrollToHero={scrollToHero} />
            <Footer />
        </div>
    )
}

const mapDispatchToProps = {
    createAccountAction: authActions.CreateAccount,
    getStoreUrlAction: authActions.GetStoreUrl,
    getStoreCategoriesAction: authActions.GetStoreCategories,
    logoutAction: authActions.Logout,
    resendActivationEmailAction: authActions.ResendActivationEmail,
    ActivateAccountWithCode: authActions.ActivateAccountWithCode,
    RequestAccountActivationCode: authActions.RequestAccountActivationCode,
    LoginAction: authActions.Login,
};

const mapStateToProps = (state: any) => ({
    getUrlRequest: state.onboardingOutboundReducers.getUrlReducer,
    getStoreCatsRequest: state.onboardingOutboundReducers.getStoreCatsReducer,
    creatUserRequest: state.onboardingOutboundReducers.creatUserReducer,
    resendActivationEmailRequest: state.onboardingOutboundReducers.resendActivationEmailReducer,
    activateAccountWithCodeRequest: state.onboardingOutboundReducers.activateAccountWithCodeReducer,
    requestAccountActivationCodeRequest: state.onboardingOutboundReducers.requestAccountActivationCodeReducer,
    loginRequest: state.onboardingOutboundReducers.loginReducer,
});
export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);
